"use client";

import { PassengersIcon } from "@/app/assets/icons";
import { ScrollableSliderProps } from "@/app/components/ScrollableSlider";
import { getStrapiMedia } from "@/app/utils/api-helpers";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { useMediaQuery } from "@/app/hooks/useMediaQuery";

export const ScrollableSliderDesktop = ({ data }: ScrollableSliderProps) => {
  const isTabletOrSmaller = useMediaQuery("(max-width:1024px)");
  const showCtaCard = isTabletOrSmaller === false;
  return (
    <div className="grid max-[980px]:grid-cols-1 max-[1300px]:grid-cols-2 min-[1301px]:grid-cols-3 gap-[24px]">
      {data?.slide?.map((item) => {
        return (
          <div
            key={item?.id}
            className="w-full p-[24px] rounded-[8px] border border-blue flex flex-col justify-between"
          >
            <div>
              <h2 className="font-bold text-[48px] leading-[48px] mb-[10px] text-center tracking-[0.04em] uppercase">
                {item?.textA}
              </h2>
              <div className="flex items-center justify-center mb-[30px]">
                <PassengersIcon className="min-w-[24px]" />
                <span className="text-[16px] leading-[16px] ml-[5px]">
                  {item?.textB}
                </span>
              </div>
              <Image
                src={
                  getStrapiMedia(item.image.data?.attributes.url ?? "") ?? ""
                }
                alt={"Preview bus"}
                width={344}
                height={240}
                className="object-cover w-full"
              />
            </div>

            <div>
              <ul className="py-[16px]  text-center">
                {item?.description?.split("\n").map((item, index) => (
                  <li
                    key={index}
                    className="font-bold text-[16px] leading-[24px] uppercase tracking-[0.08em] list-disc list-inside"
                  >
                    {item}
                  </li>
                ))}
              </ul>
              <Link
                href="#quote-page"
                className="bg-red text-white px-1/2 dt:px-[24px] py-[12px] dt:mt-1.5 rounded-[8px] uppercase font-bold text-[16px] leading-[16px] dt:leading-[24px] tracking-wider block mx-auto w-fit"
              >
                GET A QUOTE
              </Link>
            </div>
          </div>
        );
      })}
      {showCtaCard && (
        <div className="w-full p-[24px] rounded-[8px] border border-red bg-red flex flex-col justify-center items-center">
          <p className="w-[184px] text-[#fff] mb-[16px] uppercase text-[24px] leading-[24px] text-center">
            Rent <br /> a charter bus today
          </p>
          <Link
            href="#quote-page"
            className="bg-[#fff] text-red px-1/2 dt:px-[24px] py-[12px] rounded-[8px] uppercase font-bold text-[16px] leading-[16px] dt:leading-[24px] tracking-wider block mx-auto w-fit mb-[16px]"
          >
            GET A QUOTE
          </Link>
          <a
            href={`tel:888 612-1308`}
            className="text-white px-1/2 dt:px-1.5 py-1/2 rounded-1/2 uppercase font-normal text-[16px] leading-[16px]tracking-wider text-center hidden max-[560px]:block"
          >
            OR CALL <span className="font-bold">(888) 612-1308</span>
          </a>
        </div>
      )}
    </div>
  );
};
